import { useQuery } from "@tanstack/react-query";
import { useIdentity } from "../../auth/useIdentity";
import { listSellerGst, speaksGst, type SellerGst } from "../../api/priceList";

/**
 * Each line's GST and whether this operator's screens speak of GST at all
 * (owner 2026-10-29: an unregistered or composition operator sees prices with
 * no word of GST). One shared query per namespace (radaccess /gst).
 */
export function useGstWording(ns: string): { seller: SellerGst | undefined; speak: boolean; loading: boolean; error: Error | null } {
  const identity = useIdentity();
  const q = useQuery({
    queryKey: ["pricelist-gst", ns],
    enabled: Boolean(identity.token && ns),
    retry: false,
    queryFn: ({ signal }) => listSellerGst(identity, ns, signal),
  });
  return { seller: q.data, speak: speaksGst(q.data), loading: q.isLoading, error: (q.error as Error | null) ?? null };
}
